import {ImbalanceItem} from "./types";
import {adjUnits} from "./imbalanceHelpers";

export type ManualAdjustmentInput = {
    material: string;
    size: string;
    countryOfOrigin: string;
    quality: string;
    location: string;
    type: 'POSADJ' | 'NEGADJ';
    quantity: number;
    customsStatus: 'NON_BONDED' | 'BONDED';
    reason: string;
    comment: string;
    clearGoodsIfNeeded: boolean;
};

const BUCKET_PARAMS: Record<'zero' | 'under' | 'over', {
    type: 'POSADJ' | 'NEGADJ';
    reason: string;
    customsStatus: 'NON_BONDED' | 'BONDED';
    clearGoodsIfNeeded: boolean;
}> = {
    zero:  {type: 'NEGADJ', reason: 'Bulk Clean Up (no WMS inv)', customsStatus: 'NON_BONDED', clearGoodsIfNeeded: true},
    over:  {type: 'POSADJ', reason: 'Bulk Clean Up (WMS > CI)',   customsStatus: 'BONDED',     clearGoodsIfNeeded: false},
    under: {type: 'NEGADJ', reason: 'Bulk Clean Up (WMS < CI)',   customsStatus: 'NON_BONDED', clearGoodsIfNeeded: false},
};

export function toManualAdjustments(
    items: ImbalanceItem[],
    bucketKey: 'zero' | 'under' | 'over',
): ManualAdjustmentInput[] {
    const {type, reason, customsStatus, clearGoodsIfNeeded} = BUCKET_PARAMS[bucketKey];

    return items.map(item => ({
        material: item.material,
        size: item.size,
        countryOfOrigin: item.coo,
        quality: item.quality,
        location: 'ELC',
        type,
        quantity: adjUnits(item),
        customsStatus,
        reason,
        comment: '',
        clearGoodsIfNeeded,
    }));
}
